(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["myc-community-academy-editor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var VERT = 'attribute vec2 p;varying vec2 v;void main(){v=p*0.5+0.5;gl_Position=vec4(p,0.0,1.0);}';
    var FRAG = [
      'precision highp float;',
      'varying vec2 v;',
      'uniform sampler2D uFrom;',
      'uniform sampler2D uTo;',
      'uniform vec2 uRes;',
      'uniform vec2 uFromSize;',
      'uniform vec2 uToSize;',
      'uniform float uP;',
      'uniform float uDir;',
      'uniform vec3 uAccent;',
      'vec2 cover(vec2 uv, vec2 img){',
      '  float ra = uRes.x / uRes.y;',
      '  float ia = img.x / img.y;',
      '  vec2 s = ra > ia ? vec2(1.0, ia / ra) : vec2(ra / ia, 1.0);',
      '  return (uv - 0.5) * s + 0.5;',
      '}',
      'void main(){',
      '  vec3 fromC = texture2D(uFrom, cover(v, uFromSize)).rgb;',
      '  vec3 toC = texture2D(uTo, cover(v, uToSize)).rgb;',
      '  float x = uDir > 0.0 ? v.x : 1.0 - v.x;',
      '  float soft = 0.12;',
      '  float m = smoothstep(uP + soft, uP - soft, x);',      // 1 => reveal "to"
      '  vec3 col = mix(fromC, toC, m);',
      '  float line = smoothstep(soft, 0.0, abs(x - uP));',
      '  float active = step(0.001, uP) * step(uP, 0.999);',
      '  col += uAccent * line * active * 0.55;',              // volt scan edge
      '  gl_FragColor = vec4(col, 1.0);',
      '}'
    ].join('\n');

    function hexRgb(h) {
      var m = /^#?([\da-f]{6})/i.exec((h || '').trim());
      if (!m) return [0.84, 1, 0.2];
      var n = parseInt(m[1], 16);
      return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255];
    }
    function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

    function init(section) {
      if (!section || section.dataset.mycReady === 'true') return;
      section.dataset.mycReady = 'true';

      var tabs = [].slice.call(section.querySelectorAll('[data-academy-tab]'));
      var panels = [].slice.call(section.querySelectorAll('[data-academy-panel]'));
      var imgs = [].slice.call(section.querySelectorAll('[data-academy-img]'));
      var signal = section.querySelector('[data-academy-signal]');
      var countEl = section.querySelector('[data-academy-count]');
      var canvas = section.querySelector('[data-academy-canvas]');
      var viz = section.querySelector('[data-academy-frame]');
      var n = tabs.length;
      if (!n) return;

      var autoplay = section.dataset.academyAutoplay === 'true' && !REDUCE && n > 1;
      var wantGL = section.dataset.academyWebgl === 'true' && !REDUCE;
      var accent = hexRgb(getComputedStyle(section).getPropertyValue('--myc-academy-accent'));
      var current = 0;
      var busy = false;
      var hover = false;
      var inView = false;

      if (autoplay) section.classList.add('is-autoplay');

      /* ----- WebGL ----- */
      var gl = null, prog = null, uni = {}, tex = [], sizes = [], ready = [], raf = null;

      function compile(type, src) {
        var s = gl.createShader(type);
        gl.shaderSource(s, src);
        gl.compileShader(s);
        return s;
      }

      function initGL() {
        if (!wantGL || !canvas) return false;
        try {
          gl = canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, preserveDrawingBuffer: false });
        } catch (e) { gl = null; }
        if (!gl) return false;
        prog = gl.createProgram();
        gl.attachShader(prog, compile(gl.VERTEX_SHADER, VERT));
        gl.attachShader(prog, compile(gl.FRAGMENT_SHADER, FRAG));
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { gl = null; return false; }
        gl.useProgram(prog);
        var buf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
        var loc = gl.getAttribLocation(prog, 'p');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
        ['uFrom', 'uTo', 'uRes', 'uFromSize', 'uToSize', 'uP', 'uDir', 'uAccent'].forEach(function (k) {
          uni[k] = gl.getUniformLocation(prog, k);
        });
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        return true;
      }

      function makeTexture(img) {
        var t = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, t);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        try {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
        } catch (e) { return null; }
        return t;
      }

      function loadTexture(i) {
        var el = imgs[i];
        if (!el || el.tagName !== 'IMG') return; // placeholder → stays fallback
        function build() {
          if (!el.naturalWidth) return;
          var t = makeTexture(el);
          if (!t) return;
          tex[i] = t;
          sizes[i] = [el.naturalWidth, el.naturalHeight];
          ready[i] = true;
          if (i === current && !viz.parentElement.classList.contains('has-webgl')) {
            resize();
            viz.parentElement.classList.add('has-webgl');
          }
        }
        if (el.complete && el.naturalWidth) build();
        else el.addEventListener('load', build, { once: true });
      }

      function draw(fromI, toI, p, dir) {
        if (!gl || !ready[fromI] || !ready[toI]) return;
        gl.viewport(0, 0, canvas.width, canvas.height);
        gl.useProgram(prog);
        gl.uniform2f(uni.uRes, canvas.width, canvas.height);
        gl.uniform1f(uni.uP, p);
        gl.uniform1f(uni.uDir, dir);
        gl.uniform3f(uni.uAccent, accent[0], accent[1], accent[2]);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, tex[fromI]);
        gl.uniform1i(uni.uFrom, 0);
        gl.uniform2f(uni.uFromSize, sizes[fromI][0], sizes[fromI][1]);
        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_2D, tex[toI]);
        gl.uniform1i(uni.uTo, 1);
        gl.uniform2f(uni.uToSize, sizes[toI][0], sizes[toI][1]);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      }

      function drawStatic(i) { draw(i, i, 1, 1); }

      function resize() {
        if (!gl) return;
        var r = canvas.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = Math.max(1, Math.round(r.width * dpr));
        var h = Math.max(1, Math.round(r.height * dpr));
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
        if (ready[current]) drawStatic(current);
      }

      function glTransition(fromI, toI, dir, done) {
        var dur = 820, t0 = performance.now();
        if (raf) cancelAnimationFrame(raf);
        (function frame(now) {
          var p = Math.min(1, (now - t0) / dur);
          draw(fromI, toI, easeInOut(p), dir);
          if (p < 1) raf = requestAnimationFrame(frame);
          else { draw(fromI, toI, 1, dir); done(); }
        })(t0);
      }

      /* ----- state / view sync ----- */
      function setState(to) {
        tabs.forEach(function (tab, i) {
          var on = i === to;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (panel, i) {
          var on = i === to;
          panel.classList.toggle('is-on', on);
          panel.hidden = !on;
        });
        if (signal) signal.textContent = tabs[to].dataset.academySignalValue || '';
        if (countEl) countEl.textContent = String(to + 1).padStart(2, '0');
      }

      function go(to, focus) {
        to = (to % n + n) % n;
        if (to === current || busy) return;
        var from = current;
        var dir = (to === (from + 1) % n) ? 1 : (to === (from - 1 + n) % n ? -1 : (to > from ? 1 : -1));
        setState(to);
        if (focus) tabs[to].focus();
        if (gl && ready[from] && ready[to] && viz.parentElement.classList.contains('has-webgl')) {
          busy = true;
          glTransition(from, to, dir, function () { current = to; busy = false; drawStatic(to); });
        } else {
          if (imgs[from]) imgs[from].classList.remove('is-on');
          if (imgs[to]) imgs[to].classList.add('is-on');
          current = to;
        }
      }

      /* ----- interaction ----- */
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { go(i, false); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(i + 1, true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(i - 1, true); }
        });
      });

      if (autoplay) {
        section.addEventListener('animationend', function (e) {
          if (e.animationName !== 'myc-acad-fill') return;
          var t = e.target.closest ? e.target.closest('[data-academy-tab]') : null;
          if (!t || !t.classList.contains('is-active')) return;
          go(current + 1, false);
        });

        function sync() { section.classList.toggle('is-paused', hover || !inView); }
        section.addEventListener('pointerenter', function () { hover = true; sync(); });
        section.addEventListener('pointerleave', function () { hover = false; sync(); });
        section.addEventListener('focusin', function () { hover = true; sync(); });
        section.addEventListener('focusout', function () {
          if (!section.contains(document.activeElement)) { hover = false; sync(); }
        });
        section.classList.add('is-paused'); // until in view
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (ents) {
            ents.forEach(function (en) { inView = en.isIntersecting; sync(); });
          }, { threshold: 0.25 }).observe(section);
        } else { inView = true; sync(); }
      }

      /* ----- boot webgl ----- */
      if (initGL()) {
        imgs.forEach(function (_, i) { loadTexture(i); });
        var rz = null;
        window.addEventListener('resize', function () {
          if (rz) cancelAnimationFrame(rz);
          rz = requestAnimationFrame(resize);
        }, { passive: true });
        canvas.addEventListener('webglcontextlost', function (e) {
          e.preventDefault();
          if (raf) cancelAnimationFrame(raf);
          gl = null;
          viz.parentElement.classList.remove('has-webgl');
        });
      }
    }

    document.querySelectorAll('[data-myc-community-academy]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-myc-community-academy]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myc-community-challenge-editor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (!section || section.dataset.mycReady === 'true') return;
      section.dataset.mycReady = 'true';
      var steps = Array.prototype.slice.call(section.querySelectorAll('[data-myc-challenge-step]'));
      var number = section.querySelector('[data-myc-challenge-number]');
      var progress = section.querySelector('[data-myc-challenge-progress]');

      function activate(index) {
        steps.forEach(function (step, stepIndex) {
          step.classList.toggle('is-active', stepIndex === index);
        });
        if (number) number.textContent = String(index + 1).padStart(2, '0');
        if (progress) progress.style.setProperty('--myc-challenge-progress', String((index + 1) / Math.max(steps.length, 1)));
      }

      steps.forEach(function (step, index) {
        step.addEventListener('mouseenter', function () { activate(index); });
        step.addEventListener('focusin', function () { activate(index); });
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) section.classList.add('is-visible');
        });
      }, { threshold: .18 });
      observer.observe(section);

      function scrollProgress() {
        var rect = section.getBoundingClientRect();
        var travelled = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
        var index = Math.min(steps.length - 1, Math.floor(travelled * steps.length));
        if (index >= 0) activate(index);
      }

      window.addEventListener('scroll', scrollProgress, { passive: true });
      scrollProgress();
    }

    document.querySelectorAll('[data-myc-community-challenge]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-myc-community-challenge]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myc-community-cinematic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function shader(gl, type, source) {
      var item = gl.createShader(type);
      gl.shaderSource(item, source);
      gl.compileShader(item);
      if (!gl.getShaderParameter(item, gl.COMPILE_STATUS)) {
        gl.deleteShader(item);
        return null;
      }
      return item;
    }

    function createField(canvas, reduceMotion) {
      if (!canvas || reduceMotion || navigator.connection && navigator.connection.saveData) return null;
      var gl = canvas.getContext('webgl', { alpha: true, antialias: false, powerPreference: 'low-power' });
      if (!gl) return null;

      var vertex = shader(gl, gl.VERTEX_SHADER, 'attribute vec3 a;uniform float t;uniform float s;uniform vec2 r;varying float v;void main(){float q=t*.03+s*.9;float c=cos(q),d=sin(q);vec3 x=vec3(a.x*c-a.z*d,a.y,a.x*d+a.z*c);float spread=.72+s*.2;x.x*=spread;x.y+=sin(t*.18+a.x*3.1+s)*.045;float z=3.7+x.z;gl_Position=vec4(x.x/z*r.y/r.x*2.25,x.y/z*2.25,0.,1.);gl_PointSize=(1.2+3.0/z)*min(1.35,r.x/900.);v=.12+.48*(1.-abs(x.z)/2.7);}');
      var fragment = shader(gl, gl.FRAGMENT_SHADER, 'precision mediump float;varying float v;void main(){vec2 p=gl_PointCoord-.5;float d=dot(p,p);if(d>.25)discard;float a=smoothstep(.25,.02,d)*v;gl_FragColor=vec4(.84,1.,.2,a*.52);}');
      if (!vertex || !fragment) return null;

      var program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
      gl.useProgram(program);

      var mobile = window.innerWidth < 760;
      var count = mobile ? 180 : 460;
      var points = new Float32Array(count * 3);
      for (var index = 0; index < count; index += 1) {
        var angle = Math.random() * Math.PI * 2;
        var radius = .45 + Math.random() * 1.9;
        points[index * 3] = Math.cos(angle) * radius;
        points[index * 3 + 1] = (Math.random() - .5) * 3.2;
        points[index * 3 + 2] = Math.sin(angle) * radius;
      }

      var buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, points, gl.STATIC_DRAW);
      var attribute = gl.getAttribLocation(program, 'a');
      gl.enableVertexAttribArray(attribute);
      gl.vertexAttribPointer(attribute, 3, gl.FLOAT, false, 0, 0);

      var timeUniform = gl.getUniformLocation(program, 't');
      var sceneUniform = gl.getUniformLocation(program, 's');
      var resolutionUniform = gl.getUniformLocation(program, 'r');
      var scene = 0;
      var targetScene = 0;
      var frame = 0;
      var running = true;
      var last = 0;
      var dpr = Math.min(window.devicePixelRatio || 1, mobile ? 1 : 1.4);

      function resize() {
        var width = Math.max(1, Math.floor(canvas.clientWidth * dpr));
        var height = Math.max(1, Math.floor(canvas.clientHeight * dpr));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
          gl.viewport(0, 0, width, height);
        }
      }

      function draw(now) {
        if (!running) return;
        frame = requestAnimationFrame(draw);
        if (mobile && now - last < 34) return;
        last = now;
        resize();
        scene += (targetScene - scene) * .045;
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
        gl.uniform1f(timeUniform, now * .001);
        gl.uniform1f(sceneUniform, scene);
        gl.uniform2f(resolutionUniform, canvas.width, canvas.height);
        gl.drawArrays(gl.POINTS, 0, count);
      }

      function visibility() {
        running = !document.hidden;
        if (running && !frame) frame = requestAnimationFrame(draw);
        if (!running && frame) {
          cancelAnimationFrame(frame);
          frame = 0;
        }
      }

      document.addEventListener('visibilitychange', visibility);
      frame = requestAnimationFrame(draw);

      return {
        setScene: function (value) { targetScene = clamp(value, 0, 3); },
        destroy: function () {
          running = false;
          if (frame) cancelAnimationFrame(frame);
          document.removeEventListener('visibilitychange', visibility);
          gl.deleteBuffer(buffer);
          gl.deleteProgram(program);
          gl.deleteShader(vertex);
          gl.deleteShader(fragment);
        }
      };
    }

    function bindAcademy(root) {
      var academy = root.querySelector('[data-academy]');
      if (!academy) return { destroy: function () {} };
      var tabs = Array.prototype.slice.call(academy.querySelectorAll('[data-academy-tab]'));
      var panels = Array.prototype.slice.call(academy.querySelectorAll('[data-academy-panel]'));
      var signal = academy.querySelector('[data-academy-signal]');
      var signals = [root.dataset.signalFit, root.dataset.signalPerformance, root.dataset.signalCare];
      var active = 0;

      function select(index, focus) {
        active = (index + tabs.length) % tabs.length;
        academy.dataset.academyStep = String(active);
        tabs.forEach(function (tab, tabIndex) {
          var selected = tabIndex === active;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panels.forEach(function (panel, panelIndex) {
          panel.hidden = panelIndex !== active;
        });
        if (signal) signal.textContent = signals[active];
        if (focus) tabs[active].focus();
      }

      function click(event) {
        var index = Number(event.currentTarget.getAttribute('data-academy-tab'));
        if (document.startViewTransition) document.startViewTransition(function () { select(index, false); });
        else select(index, false);
      }

      function keydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        var next = active;
        if (event.key === 'ArrowLeft') next -= 1;
        if (event.key === 'ArrowRight') next += 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        select(next, true);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', click);
        tab.addEventListener('keydown', keydown);
      });
      select(0, false);

      return {
        destroy: function () {
          tabs.forEach(function (tab) {
            tab.removeEventListener('click', click);
            tab.removeEventListener('keydown', keydown);
          });
        }
      };
    }

    function findReturnedForm(documentNode, id) {
      var form = documentNode.getElementById(id);
      if (form) return form;
      documentNode.querySelectorAll('template').forEach(function (template) {
        if (!form) form = template.content.getElementById(id);
      });
      return form;
    }

    function bindForms(scope, root, productHint) {
      scope.querySelectorAll('form[data-campaign-form]:not([data-campaign-bound])').forEach(function (form) {
        form.dataset.campaignBound = 'true';
        var product = form.querySelector('[data-campaign-product]');
        if (product && productHint && !product.value) product.value = productHint;

        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var button = form.querySelector('[type="submit"]');
          var result = form.querySelector('[data-campaign-result]');
          if (button) {
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
          }
          if (result) {
            result.hidden = false;
            result.dataset.state = 'loading';
            result.textContent = root.dataset.sending;
          }

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function (response) { return response.text(); })
            .then(function (html) {
              if (/captcha|shopify-challenge/i.test(html)) {
                form.submit();
                return;
              }
              var returned = new DOMParser().parseFromString(html, 'text/html');
              var returnedForm = findReturnedForm(returned, form.id);
              if (!returnedForm) throw new Error(root.dataset.error);
              var error = returnedForm.querySelector('[data-campaign-form-error],.errors');
              if (error) throw new Error(error.textContent.trim());
              if (!returnedForm.querySelector('[data-campaign-form-success]')) throw new Error(root.dataset.error);
              form.reset();
              if (result) {
                result.dataset.state = 'success';
                result.textContent = form.getAttribute('data-success');
                result.focus();
              }
            })
            .catch(function (error) {
              if (result) {
                result.dataset.state = 'error';
                result.textContent = error.message || root.dataset.error;
                result.focus();
              }
            })
            .finally(function () {
              if (button) {
                button.disabled = false;
                button.removeAttribute('aria-busy');
              }
            });
        });
      });
    }

    function bindDrawer(root, productHint) {
      var drawer = document.querySelector('[data-campaign-drawer]');
      if (!drawer) return { destroy: function () {} };
      var panel = drawer.querySelector('[data-campaign-panel]');
      var lastFocus = null;
      document.body.appendChild(drawer);

      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
        lastFocus = null;
      }

      function open(name, trigger) {
        var template = root.querySelector('[data-campaign-template="' + name + '"]');
        if (!template || !panel) return;
        lastFocus = trigger || document.activeElement;
        panel.replaceChildren(template.content.cloneNode(true));
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        bindForms(panel, root, productHint);
        var first = panel.querySelector('input,button,a[href]');
        if (first) requestAnimationFrame(function () { first.focus(); });
      }

      function rootClick(event) {
        var trigger = event.target.closest('[data-campaign-open]');
        if (!trigger) return;
        event.preventDefault();
        open(trigger.getAttribute('data-campaign-open'), trigger);
      }

      function drawerClick(event) {
        if (!event.target.closest('[data-campaign-close]')) return;
        event.preventDefault();
        close();
      }

      function keydown(event) {
        if (event.key === 'Escape') close();
      }

      root.addEventListener('click', rootClick);
      drawer.addEventListener('click', drawerClick);
      drawer.addEventListener('keydown', keydown);

      return {
        destroy: function () {
          root.removeEventListener('click', rootClick);
          drawer.removeEventListener('click', drawerClick);
          drawer.removeEventListener('keydown', keydown);
          close();
          if (drawer.parentNode === document.body) drawer.remove();
        }
      };
    }

    function init(root) {
      if (!root || root.dataset.campaignReady) return;
      root.dataset.campaignReady = 'true';
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var query = new URLSearchParams(window.location.search);
      var productHint = query.get('product') || query.get('pair') || query.get('sku') || '';
      var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-campaign-chapter]'));
      var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-campaign-nav]'));
      var progress = root.querySelector('[data-campaign-progress]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-challenge-steps] li'));
      var challengeBar = root.querySelector('[data-challenge-bar]');
      var challengeMeter = root.querySelector('[data-challenge-meter]');
      var field = createField(root.querySelector('[data-campaign-webgl]'), reduceMotion);
      var academy = bindAcademy(root);
      var drawer = bindDrawer(root, productHint);
      var ticking = false;

      function update() {
        ticking = false;
        var rootRect = root.getBoundingClientRect();
        var total = Math.max(1, rootRect.height - window.innerHeight);
        var value = clamp(-rootRect.top / total, 0, 1);
        if (progress) progress.style.transform = 'scaleX(' + value.toFixed(4) + ')';
        var marker = window.innerHeight * .46;
        var active = chapters[0];
        chapters.forEach(function (chapter) {
          var rect = chapter.getBoundingClientRect();
          if (rect.top <= marker && rect.bottom > marker) active = chapter;
          chapter.classList.toggle('is-active', rect.top < window.innerHeight * .76 && rect.bottom > window.innerHeight * .24);
        });
        navLinks.forEach(function (link) {
          var current = active && link.getAttribute('href') === '#' + active.id;
          if (current) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        if (field && active) field.setScene(Number(active.getAttribute('data-campaign-scene')) || 0);

        var challenge = root.querySelector('.myc-campaign-challenge');
        if (challenge && steps.length) {
          var rect = challenge.getBoundingClientRect();
          var challengeProgress = clamp((window.innerHeight * .58 - rect.top) / Math.max(1, rect.height * .64), 0, .999);
          var stepIndex = Math.min(steps.length - 1, Math.floor(challengeProgress * steps.length));
          steps.forEach(function (step, index) { step.classList.toggle('is-active', index === stepIndex); });
          if (challengeBar) challengeBar.style.transform = 'scaleX(' + ((stepIndex + 1) / steps.length).toFixed(2) + ')';
          if (challengeMeter) challengeMeter.textContent = '0' + (stepIndex + 1);
        }
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      requestAnimationFrame(function () {
        root.classList.add('is-ready');
        update();
      });

      root._campaignDestroy = function () {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        academy.destroy();
        drawer.destroy();
        if (field) field.destroy();
        root.removeAttribute('data-campaign-ready');
      };
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-myc-campaign]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
    else boot(document);

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-myc-campaign]');
      if (root && root._campaignDestroy) root._campaignDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myc-community-loop-editor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (!section || section.dataset.mycReady === 'true') return;
      section.dataset.mycReady = 'true';

      var drawer = section.querySelector('[data-myc-register-drawer]');
      var openButton = section.querySelector('[data-myc-open-register]');
      var closeButtons = section.querySelectorAll('[data-myc-close-register]');
      var form = section.querySelector('[data-myc-register-form]');
      var result = section.querySelector('[data-myc-register-result]');
      var lastFocus;

      function openDrawer() {
        if (!drawer) return;
        lastFocus = document.activeElement;
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        window.setTimeout(function () {
          var feedback = drawer.querySelector('[data-myc-register-feedback]');
          var focusTarget = feedback ? result : drawer.querySelector('input:not([type="hidden"])');
          if (focusTarget) focusTarget.focus();
        }, 50);
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      if (openButton) openButton.addEventListener('click', openDrawer);
      closeButtons.forEach(function (button) { button.addEventListener('click', closeDrawer); });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
      });

      // Let Shopify submit the native contact form and complete CAPTCHA as needed.
      // Only show confirmation from Shopify's server-rendered form result.
      if (form && form.querySelector('[data-myc-register-feedback]')) openDrawer();
    }

    document.querySelectorAll('[data-myc-community-loop]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-myc-community-loop]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myc-community-reviews-editor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (!section || section.dataset.mycReady === 'true') return;
      section.dataset.mycReady = 'true';

      var revealItems = section.querySelectorAll('[data-myc-reveal]');
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      }, { threshold: .14 });
      revealItems.forEach(function (item) { revealObserver.observe(item); });

      var stories = section.querySelector('[data-myc-community-stories]');
      var storyProgress = section.querySelector('[data-myc-story-progress]');
      var motionOkay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoTimer;

      function updateStoryProgress() {
        if (!stories || !storyProgress) return;
        var maxScroll = Math.max(stories.scrollWidth - stories.clientWidth, 1);
        var progress = Math.min(100, Math.max(8, stories.scrollLeft / maxScroll * 100));
        storyProgress.style.width = progress + '%';
      }

      function advanceStories() {
        if (!stories || stories.scrollWidth <= stories.clientWidth) return;
        var firstCard = stories.querySelector('.myc-community-reviews__story');
        var step = firstCard ? firstCard.getBoundingClientRect().width + 12 : stories.clientWidth * .8;
        var atEnd = stories.scrollLeft + stories.clientWidth >= stories.scrollWidth - 12;
        stories.scrollTo({ left: atEnd ? 0 : stories.scrollLeft + step, behavior: 'smooth' });
      }

      function startStories() {
        if (!motionOkay || !stories || autoTimer) return;
        autoTimer = window.setInterval(advanceStories, 4200);
      }

      function stopStories() {
        window.clearInterval(autoTimer);
        autoTimer = null;
      }

      if (stories) {
        stories.addEventListener('scroll', updateStoryProgress, { passive: true });
        stories.addEventListener('pointerenter', stopStories);
        stories.addEventListener('pointerleave', startStories);
        stories.addEventListener('focusin', stopStories);
        stories.addEventListener('focusout', startStories);
        updateStoryProgress();
        startStories();
      }

      var drawer = section.querySelector('[data-myc-register-drawer]');
      var openButton = section.querySelector('[data-myc-open-register]');
      var closeButtons = section.querySelectorAll('[data-myc-close-register]');
      var form = section.querySelector('[data-myc-register-form]');
      var submitButton = section.querySelector('[data-myc-register-submit]');
      var result = section.querySelector('[data-myc-register-result]');
      var lastFocus;

      function openDrawer() {
        if (!drawer) return;
        lastFocus = document.activeElement;
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        window.setTimeout(function () {
          var firstInput = drawer.querySelector('input:not([type="hidden"])');
          if (firstInput) firstInput.focus();
        }, 50);
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      if (openButton) openButton.addEventListener('click', openDrawer);
      closeButtons.forEach(function (button) { button.addEventListener('click', closeDrawer); });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
      });

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (!form.reportValidity()) return;
          if (submitButton) submitButton.disabled = true;
          if (result) result.textContent = section.dataset.sendingText || 'Connecting your pair…';

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Registration failed');
            form.reset();
            if (result) result.textContent = section.dataset.successText || 'Your pair is registered.';
          }).catch(function () {
            if (result) result.textContent = section.dataset.errorText || 'We could not confirm the registration. Please try again.';
          }).finally(function () {
            if (submitButton) submitButton.disabled = false;
          });
        });
      }
    }

    document.querySelectorAll('[data-myc-community-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-myc-community-reviews]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myc-home-reviews"] && !Shopify.designMode) return;
  try {
    
/* Reviews rail — 3D coverflow + auto-advance.
   JS adds .is-3d so the grid only becomes a rail when scripting is available;
   without JS it stays the original static grid. Card transforms are painted
   from scroll position on rAF (same approach as the video carousel). */
(function () {
  function initRail(rail) {
    if (!rail || rail.dataset.revInit) return;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('.myc-hrev__card'));
    if (cards.length < 2) return;
    rail.dataset.revInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    rail.classList.add('is-3d');

    /* ---- paint: signed distance from rail centre -> --rev-t / --rev-d ---- */
    var ticking = false;
    function paint() {
      ticking = false;
      var rect = rail.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      var half = (rect.width / 2) || 1;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var t = ((r.left + r.width / 2) - mid) / half;
        if (t > 1) t = 1; else if (t < -1) t = -1;
        cards[i].style.setProperty('--rev-t', t.toFixed(3));
        cards[i].style.setProperty('--rev-d', Math.abs(t).toFixed(3));
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }
    rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paint();

    /* ---- auto-advance ---- */
    var autoplay = rail.getAttribute('data-autoplay') === '1';
    var dwell = (parseFloat(rail.getAttribute('data-dwell')) || 5) * 1000;
    if (dwell < 2000) dwell = 2000;
    var timer = null, paused = false, inView = false, idle = null, autoScrolling = false;

    function indexAtCentre() {
      var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs((cards[i].offsetLeft + cards[i].offsetWidth / 2) - mid);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function advance() {
      var next = (indexAtCentre() + 1) % cards.length;
      var target = cards[next].offsetLeft - (rail.clientWidth - cards[next].offsetWidth) / 2;
      autoScrolling = true;
      rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      setTimeout(function () { autoScrolling = false; }, 800);
    }
    function tick() { if (!paused && inView && !reduce.matches) advance(); }
    function start() { if (timer || !autoplay) return; timer = setInterval(tick, dwell); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    ['pointerenter', 'focusin'].forEach(function (e) {
      rail.addEventListener(e, function () { paused = true; });
    });
    ['pointerleave', 'focusout'].forEach(function (e) {
      rail.addEventListener(e, function () { paused = false; });
    });
    // A visitor's own scroll pauses autoplay briefly so the two never fight.
    // Programmatic scrolls set autoScrolling so they don't pause themselves.
    rail.addEventListener('scroll', function () {
      if (autoScrolling) return;
      paused = true;
      clearTimeout(idle);
      idle = setTimeout(function () { paused = false; }, 2500);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        inView = en[0].isIntersecting;
        if (inView) start(); else stop();
      }, { threshold: 0.35 }).observe(rail);
    } else { inView = true; start(); }

    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () { if (reduce.matches) stop(); else start(); });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-myc-rev-rail]').forEach(initRail);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
